"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreatorDataInfo = void 0;
const useStore_1 = require("root/src/client/logic/helpers/useStore");
const socialLinksSelector_1 = __importDefault(require("root/src/client/logic/creatorData/selectors/socialLinksSelector"));
const useCreatorData_1 = require("root/src/client/logic/api/hooks/useCreatorData");
const useCreatorProfile_1 = require("root/src/client/logic/api/hooks/useCreatorProfile");
const isOwnProfileSelector_1 = __importDefault(require("root/src/client/logic/creatorData/selectors/isOwnProfileSelector"));
const useCreatorDataInfo = () => {
    const socialLinks = (0, useStore_1.useAppSelector)(socialLinksSelector_1.default);
    const creatorData = (0, useCreatorData_1.useCreatorData)();
    const profile = (0, useCreatorProfile_1.useCreatorProfile)();
    const isOwnProfile = (0, useStore_1.useAppSelector)(isOwnProfileSelector_1.default);
    return {
        creatorData,
        profile,
        isOwnProfile,
        socialLinks,
    };
};
exports.useCreatorDataInfo = useCreatorDataInfo;
